/// <reference types="vite/client" />
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL!;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type UserRole = 'admin' | 'docente' | 'studente';

export interface Profile {
  id: string;
  email: string;
  full_name: string | null;
  first_name: string | null;
  last_name: string | null;
  birth_date: string | null;
  phone: string | null;
  address: string | null;
  postal_code: string | null;
  city: string | null;
  role: UserRole;
  avatar_url: string | null;
  bio: string | null;
  subject_id: string | null;
  teaches_in_institution: boolean;
  institution_name: string | null;
  teaching_experience_years: number;
  qualifications: string | null;
  paypal_merchant_id: string | null;
  reward_points: number;
  is_teacher: boolean;
  active_role: 'studente' | 'docente';
  created_at: string;
  updated_at: string;
}
